// export const DOMAIN_URI = 'https://api.new.avixena.com'; // PROD
export const DOMAIN_URI = 'https://api.dev.avixena.com';  // dev
// export const MAIN_URI = 'https://new.avixena.com';  // PROD
export const MAIN_URI = 'https://dev.avixena.com';  // dev
export const API_URI = `${DOMAIN_URI}/api/v1/`;
